import React from 'react';
import ListChecklistIcon from '@atlaskit/icon/core/list-checklist';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { Flex, Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { useIntl, defineMessages } from '@atlassian/jira-intl';

const styles = cssMap({
	icon: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		paddingLeft: token('space.075'),
		paddingRight: token('space.025'),
	},
});

const messages = defineMessages({
	tooltipWhenComplete: {
		id: 'platform-board-kit.common.column-header.editable-title.last-column-checklist.tooltip-when-complete',
		defaultMessage:
			'Work items moved to this column will be counted as completed when you complete the sprint',
		description:
			'Tooltip for the list checklist icon in the header of the last column on the board.',
	},
	tooltipWhenDoneAndComplete: {
		id: 'platform-board-kit.common.column-header.editable-title.last-column-checklist.tooltip-when-done-and-complete',
		defaultMessage:
			'Work items moved to this column are marked as done, and will be counted as completed when you complete the sprint',
		description:
			'Tooltip for the list checklist icon in the header of the last column on the board when the column is also the done column.',
	},
	checklistIconLabel: {
		id: 'platform-board-kit.common.column-header.editable-title.last-column-checklist.checklist-icon-label',
		defaultMessage: 'Checklist icon',
		description:
			'A11y label for a checklist icon to indicate that work items in the last column on the board will be counted as complete when the sprint is completed.',
	},
});

export const LastColumnChecklist = ({ isDoneColumn }: { isDoneColumn: boolean }) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.icon}>
			<Tooltip
				content={
					isDoneColumn
						? formatMessage(messages.tooltipWhenDoneAndComplete)
						: formatMessage(messages.tooltipWhenComplete)
				}
				position="bottom"
			>
				{/* Flex forces ListChecklistIcon to not expand to its natural lineHeight */}
				<Flex>
					<ListChecklistIcon
						label={formatMessage(messages.checklistIconLabel)}
						color={token('color.icon.success')}
						LEGACY_size="small"
					/>
				</Flex>
			</Tooltip>
		</Box>
	);
};
